import { apiRequest } from "../api/apiClient";
import { Car } from "../types/car.types";

const ROUTE_PREFIX = "myCars";

const getCars = async (carIds: string[]) => {
  const params = new URLSearchParams();
  params.append("ids", JSON.stringify(carIds));
  const query = params.toString();

  const { data, error } = await apiRequest("get", `/${ROUTE_PREFIX}?${query}`);
  return { data, error };
};

const addCar = async (
  number: string,
  brand: string,
  model: string,
  carType: string,
  kms: string,
  insuranceExpiry: string | null,
  year: string,
  fuelType: string,
  lastServiceKms: string,
  lastServiceDate: string | null,
  driveFrequency: string
) => {
  const { data, error } = await apiRequest("post", `/${ROUTE_PREFIX}`, {
    number,
    brand,
    model,
    carType,
    kms,
    insuranceExpiry,
    year,
    fuelType,
    lastServiceDate,
    lastServiceKms,
    driveFrequency,
  });

  return { data, error };
};

const updateCar = async (updateDetails: Partial<Car>, carId: string) => {
  const { data, error } = await apiRequest(
    "patch",
    `/myCars/${carId}`,
    updateDetails
  );
  return { data, error };
};

const removeCar = async (carId: string) => {
  const { data, error } = await apiRequest("delete", `/myCars/${carId}`);

  return { data, error };
};

export { addCar, getCars, updateCar, removeCar };
